import { type InteractionEvent, type TrackingParameterValue } from '@/tracking/types';

export function isGTMEnabled(): boolean {
  return typeof window !== 'undefined' && !!window.dataLayer;
}

export const trackEvent = (
  eventName: InteractionEvent,
  eventParams: Record<string, TrackingParameterValue> = {},
): void => {
  if (!isGTMEnabled()) {
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
};
